import dayjs from "dayjs";
import { lazy, Suspense } from "react";
import { getWoWPlaces } from "../../api/user";
import { Theme } from "../../data/style/Theme";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/AuthContext";
import useScreenSize from "../../context/ScreenContext";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const NoDataDiv = lazy(() => import("../Display/NoDataDiv"));

const CustomTooltip = ({ active, payload }) => {
  // console.log(active);

  // console.log(payload);
  // if (active && payload && payload.length) {
  //   var data = payload[0].payload;
  //   var start_date = dayjs(payload[0].payload.created_at).format("DD/MM");
  //   var end_date = dayjs(payload[0].payload.created_at)
  //     .add(6, "day")
  //     .format("DD/MM");
  //   var period = start_date + "-" + end_date;
  //   return (
  //     <Stack
  //       gap={1}
  //       sx={{
  //         width: "300px",
  //         borderRadius: "16px",
  //         background: "black",
  //       }}
  //     >
  //       <SmallWodDisplay wodId={data.wod} place={data.place} period={period} />
  //     </Stack>
  // );
  // }

  return null;
};

const axisClass = {
  fill: Theme.palette.text,
  fontFamily: "Oswald, sans-serif",
  fontSize: "0.8rem",
};

const WodStandingsChart = () => {
  const { user } = useAuth();
  const { mobileDevice } = useScreenSize();

  const { data } = useQuery({
    queryKey: ["user", user.id, "wow", "places"],
    queryFn: ({ signal }) => getWoWPlaces({ signal }),
  });

  return (
    <>
      {data?.length > 0 ? (
        <ResponsiveContainer width="100%" height="98%">
          <LineChart
            data={data}
            margin={{
              top: 20,
              right: 20,
              left: -20,
              bottom: -10,
            }}
          >
            <XAxis tick={axisClass} dataKey={"date"} />
            <YAxis
              allowDecimals={false}
              tick={axisClass}
              reversed
              domain={[20, 1]}
            />
            <Line
              type={"monotone"}
              dataKey={"place"}
              stroke={Theme.palette.orange}
              activeDot={{ r: 8 }}
              strokeWidth={2}
            />
            <Tooltip
              position={{
                y: mobileDevice ? -100 : -100,
                x: mobileDevice && 0,
              }}
              content={<CustomTooltip />}
            />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <Suspense>
          <NoDataDiv
            text={"No data available."}
            icon={
              <QueryStatsIcon
                sx={{
                  fontSize: mobileDevice ? "3rem" : "4rem",
                  color: Theme.palette.orange,
                }}
              />
            }
            height={"100%"}
            minHeight={"150px"}
          />
        </Suspense>
      )}
    </>
  );
};

export default WodStandingsChart;
